export const parseDescription = (description) => {
  const sections = [];
  const lines = description?.split("\n"); // Split the text into lines

  let currentSection = { title: "", content: "" };

  lines?.forEach((line) => {
    // Check for section title (starts with ★ and ends with ★)
    if (line.trim().startsWith("★") && line.trim().endsWith("★")) {
      if (currentSection.title) {
        sections.push(currentSection); // Save the previous section
      }
      currentSection = { title: line.trim().replace(/★/g, ""), content: "" };
    } else {
      currentSection.content += line.trim() ? `${line.trim()} ` : ""; // Add content to the current section
    }
  });

  // Add the last section
  if (currentSection.title) {
    sections.push(currentSection);
  }

  return sections;
};
